import { AnaColumn } from "../forms-template.service";

export const serviceRentriRegistriElenco: AnaColumn[] = [

  {
    itemType: "group", caption: 'Registri RENTRi', class: '', colCount: "1", data: [


      {
        type: 'button',
        colVisible: true,
        visible: true,
        dataField: "",
        horizontalAlignment: 'center',
        verticalAlignment: 'center',
        class: '',
        caption: " ",
        button:
        {
          event: "selezionaRegistro",
          name: "selezionaRegistro",
          hint: "Seleziona registro rentri",
          icon: "bi bi-box-arrow-up-right selezionaRegistro",
          class: '',
        },
      },
      {
        type: 'button',
        colVisible: true,
        visible: true,
        dataField: "",
        horizontalAlignment: 'center',
        verticalAlignment: 'center',
        class: '',
        caption: " ",
        button:
        {
          event: "chiudiRegistro",
          name: "chiudiRegistro",
          hint: "Chiudi registro rentri",
          icon: "bi bi-x-circle text-danger chiudiRegistro",
          class: '',
        }
      },
      {
        type: 'campo', dataField: "identificativo", colVisible: true, dataType: "", caption: "Codice registro", hideOnEdit: true,
        colWidth: 100,
      },
      {
        type: 'campo', dataField: "descrizione", colVisible: true, dataType: "", caption: "Descrizione", hideOnEdit: true,

      },
      {
        type: 'campo', dataField: "num_iscr_sito", colVisible: false, dataType: "", caption: "Codice struttura", hideOnEdit: true,
        colWidth: 170,

      },
      {
        type: 'campo', dataField: "attivita", colVisible: true, dataType: "", caption: "Tipo Attività", hideOnEdit: true, allowFiltering: false,
      },
      {
        type: 'campo', dataField: "attivita_rec_smalt", colVisible: true, dataType: "", caption: "Attività", hideOnEdit: true, allowFiltering: false,
      },
      {
        type: 'campo', dataField: "numero_movimenti", colVisible: true, dataType: "number", caption: "N.Movimenti", hideOnEdit: true, allowFiltering: false,
      },


      {
        type: 'campo', dataField: "data_creazione", colVisible: true, dataType: "date", caption: "Data creazione", hideOnEdit: true,
        mask: 'dd/MM/yyyy',
        colWidth: 90,
      },


    ]

  }]